import { ref } from 'vue';
import type { Approval, ClientContact } from '~/types/models';

export function useClientWorkspaceDialogs() {
    const isSendFormOpen = ref(false);
    const isCreateQuoteOpen = ref(false);
    const isCreateInvoiceOpen = ref(false);
    const isOnboardingHandoffOpen = ref(false);
    const isOverviewNotesOpen = ref(false);
    const isOverviewAttentionOpen = ref(false);
    const selectedOverviewAttentionCardId = ref<string | null>(null);
    const isContactOpen = ref(false);
    const editingContact = ref<ClientContact | null>(null);
    const isClientSettingsOpen = ref(false);
    const isQuickLinksOpen = ref(false);
    const selectedApproval = ref<Approval | null>(null);
    const isApprovalOpen = ref(false);

    return {
        isSendFormOpen,
        isCreateQuoteOpen,
        isCreateInvoiceOpen,
        isOnboardingHandoffOpen,
        isOverviewNotesOpen,
        isOverviewAttentionOpen,
        selectedOverviewAttentionCardId,
        isContactOpen,
        editingContact,
        isClientSettingsOpen,
        isQuickLinksOpen,
        selectedApproval,
        isApprovalOpen,
    };
}
